import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { ProfileMenuComponent } from './profile-menu.component';
import { AccountIconComponent } from '../shared/account-icon.component';

/**
 * Kept apart from the account pages so the eagerly loaded Switch Account screen can show the
 * user menu without pulling the whole account-settings bundle (PDF viewer included) into main.
 */
@NgModule({
  declarations: [ProfileMenuComponent, AccountIconComponent],
  imports: [CommonModule, NzAvatarModule],
  exports: [ProfileMenuComponent, AccountIconComponent],
})
export class ProfileMenuModule {}
